import { Record } from 'immutable';
import { Base } from './base';

class SupplyNode extends Base(Record({
    id: null,
    purchaser_id: null,
    supplier_id: null
  })) {
    $delete() {
      return this.api.delete({
        id: this.id,
        resource: 'supply_nodes'
      })
      .then(res => this.dispatch(this.actions.clearEntity(this, 'supplyNodes')));
    }

    $get(id) {
      if (!id) id = this.purchaser_id;

      return this.api.get({
        resource: 'supply_nodes?filter[purchaser_id]=' + id
      })
      .then(res => this.dispatch(this.actions.receiveEntities(res.data, 'supplyNodes')))
      .then(res => this.api.get({
        resource: 'supply_nodes?filter[supplier_id]=' + id
      }))
      .then(res => this.dispatch(this.actions.receiveEntities(res.data, 'supplyNodes')));
    }
  }

export default SupplyNode;



// WEBPACK FOOTER //
// ./src/records/supply-node.js